/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import {
  View,
  Image,
  StyleSheet,
  Dimensions,
  ActivityIndicator,
} from 'react-native';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n } from '../lib/lang';
import { DyteUIContext } from '../lib/context-provider/ui-context';
import DyteSpinner from './DyteSpinner';

export default function ({
  message,
  iconPack = defaultIconPack,
  isContinued = false,
  now = new Date(),
  t,
}: {
  message: any;
  iconPack?: IconPack;
  isContinued?: boolean;
  now?: Date;
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const [loading, setLoading] = useState(true);
  iconPack = iconPack ?? defaultIconPack;
  const stopLoading = () => {
    setLoading(false);
  };
  const styles = StyleSheet.create({
    imageContainer: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
    },
    image: {
      flex: 1,
      minHeight: loading ? 1 : 300,
      minWidth: loading ? 1 : 300,
    },
    loadingIndicator: {
      flex: 1,
      minHeight: 300,
      minWidth: 300,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
  return (
    <View style={styles.imageContainer}>
      {loading && (
        <View style={styles.loadingIndicator}>
          <DyteSpinner />
        </View>
      )}
      <Image
        style={styles.image}
        resizeMethod={'auto'}
        resizeMode={storeStates.activeFullscreen ? 'contain' : 'cover'}
        onLoad={(e) => stopLoading()}
        source={{
          uri:
            message !== undefined
              ? message.link
              : 'https://images.unsplash.com/photo-1657788913374-11f55e6afefe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1636&q=80',
        }}
      />
    </View>
  );
}
